import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Button, Typography } from '@mui/material';
import { Replay } from '@mui/icons-material';
import ChatChannel from '../ChatChannel';
import LoadingProgress from '../../../../../components/LoadingProgress';

import { useMytaverseEvent } from '../../../providers';
import { useChatState } from '../../../../../hooks/context';
import { useRetryConnectionToChannels } from '../../../hooks/channel';
import { useStyles } from './styles';

import { checkIsGlobalTab } from '../helpers';
import { checkIsAdminRole } from '../../../../../helpers/role';

const EventTab = () => {
  const { eventStreamChannel, activeTab, streamClient } = useChatState();
  const { currentEvent, currentEventId, currentParticipantId } =
    useMytaverseEvent();
  const { reconnectToEventStreamChannel } = useRetryConnectionToChannels();
  const classes = useStyles();
  const [isRetryingLoading, setIsRetryingLoading] = useState(false);
  const { t: translate } = useTranslation('common');

  const retryReconnect = async () => {
    setIsRetryingLoading(true);
    if (streamClient && currentEventId && currentParticipantId) {
      await reconnectToEventStreamChannel({
        streamClient,
        userId: currentParticipantId,
        eventId: currentEventId,
      });
    }
    setIsRetryingLoading(false);
  };

  const isGlobalTab = checkIsGlobalTab(activeTab);
  if (!currentEvent || !isGlobalTab) {
    return <LoadingProgress />;
  } else if (!eventStreamChannel) {
    return (
      <Stack flexDirection="column" justifyContent="center" alignItems="center">
        <Typography sx={classes.text}>
          {translate('chatDrawer.connectionFailed')}
        </Typography>
        {isRetryingLoading && <LoadingProgress height="auto" />}
        {!isRetryingLoading && (
          <Button
            sx={classes.button}
            variant="outlined"
            startIcon={<Replay />}
            onClick={retryReconnect}
          >
            {translate('chatDrawer.retryConnecting')}
          </Button>
        )}
      </Stack>
    );
  }

  const isAdminRole = checkIsAdminRole(currentEvent.role);

  return (
    <ChatChannel channel={eventStreamChannel} showClearChat={isAdminRole} />
  );
};

export default EventTab;
